import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchPublishedPostsWithPagination } from 'dash-front/campaign/actions/withPagination';
import { selectIds } from 'dash-front/selectors/pagination';
import { getQueries } from 'dash-front/selectors';
import PublishedPost from './PublishedPost';
import { FINISHED_REQ_DELAY } from 'dash-front/constants';
import { TextBlock } from 'react-placeholder/lib/placeholders';
import { LOADING_CLASSNAME, LOADING_COLOR } from 'dash-front/constants';
import Pagination from '../Pagination';
import { responseStatusIsOk, toIdArray } from 'dash-front/helpers';
import { fetchStats } from 'dash-front/campaign/actions/postStats';

const FETCH_INTERVAL_SEC = 15;
const PublishedList = connect(
    (state, { campaignId }) => ({
        postIds: selectIds(state.pagination, `published/${campaignId}`),
        isFinished: _.get(getQueries(state), [`GET:published/${campaignId}`, 'isFinished'])
    }),
    dispatch => ({
        fetchPosts: campaignId => dispatch(fetchPublishedPostsWithPagination(campaignId)),
        fetchStats: publicationIds => dispatch(fetchStats(publicationIds))
    })
)(
    class _PublishedList extends React.PureComponent {
        constructor(props, ctx) {
            super(props, ctx);
            this.state = {
                ready: Boolean(props.isFinished)
            };
            this.timer = null;
        }

        fetchPostsWithStats = () => {
            const { campaignId } = this.props;
            this.props.fetchPosts(campaignId).then(res => {
                if (responseStatusIsOk(res.status) && Array.isArray(res.body.posts)) {
                    const publicationIds = res.body.posts
                        .reduce((acc, post) => acc.concat(toIdArray(post.publications)), [])
                        .filter(e => e);
                    this.props.fetchStats(publicationIds);
                }
            });
        };

        componentDidMount() {
            const { campaignId } = this.props;
            this.fetchPostsWithStats();
            this.fetchInterval = window.setInterval(() => {
                this.props.fetchPosts(campaignId);
            }, FETCH_INTERVAL_SEC * 1000);
        }

        componentWillReceiveProps({ isFinished, postIds }) {
            if (isFinished !== this.props.isFinished) {
                if (isFinished) {
                    window.clearTimeout(this.timer);
                    this.timer = setTimeout(() => this.setState({ ready: isFinished }), FINISHED_REQ_DELAY);
                } else {
                    window.clearTimeout(this.timer);
                    this.setState({
                        ready: isFinished || Array.isArray(postIds)
                    });
                }
            }
        }

        componentWillUnmount() {
            window.clearInterval(this.fetchInterval);
        }

        render() {
            const { ready } = this.state;
            const { postIds, isFinished, campaignId } = this.props;
            const canShow = ready && Array.isArray(postIds);
            return !canShow ? (
                <TextBlock rows={7} className={LOADING_CLASSNAME} color={LOADING_COLOR} />
            ) : (
                <div>
                    {postIds.map((id, index) => (
                        <div key={canShow ? id : index}>
                            <PublishedPost id={id} />
                        </div>
                    ))}
                    {postIds.length !== 0 && (
                        <div style={{ margin: '12px 0px' }}>
                            <Pagination
                                entity={`published/${this.props.campaignId}`}
                                fetchFunction={this.fetchPostsWithStats}
                            />
                        </div>
                    )}
                    {postIds.length === 0 && (
                        <div className="empty-message" style={{ margin: '12px 0px' }}>
                            There is no published posts yet.
                        </div>
                    )}
                </div>
            );
        }
    }
);

export default PublishedList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/PublishedList.js
 **/